import { createSlice } from "@reduxjs/toolkit";



const mockPreRegisterDevices = [
  {
    "code": 1,
    "macAddress": "34:7C:12:FA:89:4E",
    "snInformation": "42847103850629",
    "modelName": "DAP-E9560",
  },
  {
    "code": 0,
    "macAddress": "91:BC:33:4F:22:A1",
    "snInformation": "37812847824847",
    "modelName": "DAP-3060",
  },
  {
    "code": 0,
    "macAddress": "F0:18:5D:92:77:C3",
    "snInformation": "",
    "modelName": "DAP-3060w",
  },
  {
    "code": 1,
    "macAddress": "F0:1B:5D:92:77:C3",
    "snInformation": "11128338847304",
    "modelName": "DXS-3130-28P",
  },
  {
    "code": 0,
    "macAddress": "6B:44:8E:10:CC:5F",
    "snInformation": "3839057509482",
    "modelName": "DMS-1250-10S",
  },
  {
    "code": 0,
    "macAddress": "8D:2A:6F:33:B1:9E",
    "snInformation": "1375648506891",
    "modelName": "DAP-2620",
  },
  {
    "code": 1,
    "macAddress": "C4:9F:21:DE:48:72",
    "snInformation": "42847103850629",
    "modelName": "DAP-E9560",
  },
  {
    "code": 0,
    "macAddress": "E7:55:0A:6C:90:1D",
    "snInformation": "37812847824847",
    "modelName": "DAP-3060",
  },
];

export const preRegisterSlice = createSlice({
  name: "addDevicePreRegisterOrgDevices",
  initialState: {
    resource: 'preRegisterDevices',
    data: [...mockPreRegisterDevices],
  },
});

export default preRegisterSlice.reducer;